import { render, staticRenderFns } from "./AddBdoCardTemplate.vue?vue&type=template&id=5c27825c&"
import script from "./AddBdoCardTemplate.vue?vue&type=script&lang=js&"
export * from "./AddBdoCardTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports